'use client';
import React from 'react';
import { ProductRating as SharedProductRating } from '@launchstore/shared-puck';
import type { ProductRatingProps, FetchProductReviews, ProductRatingSummary } from '@launchstore/shared-puck';
import { useProduct } from '@/lib/hooks/useProduct';
import type { ProductData } from '@launchstore/shared-puck';
import { fetchProductReviews } from '@/lib/data/reviews';

const toProductData = (p: any): ProductData | null => {
  if (!p) return null;
  return { id: p.id, title: p.title };
};

const adaptFetchReviews: FetchProductReviews = async (productId: string, opts?: { limit?: number }) => {
  try {
    const data = await fetchProductReviews(productId, { limit: opts?.limit } as any);
    const summary: ProductRatingSummary = {
      average_rating: (data as any).average_rating ?? 0,
      count: (data as any).count ?? 0,
    };
    return summary;
  } catch {
    return null;
  }
};

const SharedProductRatingRender = (SharedProductRating as any).render;

const ProductRatingImpl: React.FC<ProductRatingProps> = (props: any) => {
  const { product } = useProduct();
  return <SharedProductRatingRender {...(props as any)} product={toProductData(product)} fetchReviews={adaptFetchReviews} />;
};

export const ProductRating: any = { ...SharedProductRating, render: (props: any) => <ProductRatingImpl {...props} /> };
export default ProductRating;
